exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/*Devices*/\r\n/*Colors*/\r\n/*Syles*/\r\n/*Buttons*/\r\n/*Functions*/\r\n@media (min-width: 0px) {\r\n  .form-label-required:after {\r\n    content: \"*\"; }\r\n  .form-label-optional:after {\r\n    content: \" (Optional)\"; } }\r\n", ""]);

